import { Link } from "react-router-dom";

export default function PostItem({ post }) {
  const { image, title, likes, isSaved, createdAt, tags, id } = post;
  return (
    <div className="lws-card">
      <Link to={`/posts/${id}`}>
        <img
          src={image}
          className="lws-card-image"
          alt="Top Github Alternatives"
        />
      </Link>
      <div className="p-4">
        <div className="lws-card-header">
          <p className="lws-publishedDate">{createdAt}</p>
          <p className="lws-likeCount">
            <i className="fa-regular fa-thumbs-up" />
            {likes}
          </p>
        </div>
        <Link to={`/posts/${id}`} className="lws-postTitle">
          {" "}
          {title}{" "}
        </Link>
        <div className="lws-tags">
          {tags.map((tag) => (
            <span key={tag}>#{tag},</span>
          ))}
        </div>

        {isSaved && (
          <div className="flex gap-2 mt-4">
            <span className="lws-badge"> Saved </span>
          </div>
        )}
      </div>
    </div>
  );
}
